import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Direction = iotsUtils.fromList(
	constants.job.trussHitl.polygon.slopeDirection.directions
);
